export function newConversation() {
  if (typeof drift === 'undefined' || drift === null) { return }
  return drift.on('ready', api => api.sidebar.open())
}

export function openSidebar() {
  if (typeof drift === 'undefined' || drift === null) { return }
  return drift.on('ready', api => api.sidebar.open())
}

export function showWelcomeMessage(options) {
  if (typeof drift === 'undefined' || drift === null) { return }
  return drift.on('ready', api => api.showWelcomeMessage(options))
}

export function hideWidget() {
  if (typeof drift === 'undefined' || drift === null) { return }
  return drift.hide()
}

export function trackPage() {
  if (typeof drift === 'undefined' || drift === null) { return }
  return drift.page()
}

export function showWidget() {
  if (typeof drift === 'undefined' || drift === null) { return }
  return drift.show()
}



// WEBPACK FOOTER //
// ./src/scripts/utils/DrifttHelpers.js